import { Box, CircularProgress, Stack, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Color, FontStyle, Slug, userStr } from "../../constants";
import { parseDate, prettyDate, prettyDateShort } from "../../utils/utils";
import FettiLongInput from "../FettiLongInput";
import {
  // loadCompanyInfo,
  // loadJobs,
  setChatInput,
} from "../../utils/actionUtils";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChatInput from "./ChatInput";
import * as apiService from "../../service/ApiService";
import ReplayIcon from "@mui/icons-material/Replay";
import RetryButton from "./RetryButton";

const ApplicationAttachment = ({ applicationId }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const appData = useSelector((state) => state.apply.myApps.appData);
  useEffect(() => {
    if (applicationId && !appData[applicationId]) {
      // todo: load application attachment
      apiService.getApplicationData(
        dispatch,
        {
          ...auth.accountData,
          applicationId,
        },
        {}
      );
    }
  }, [applicationId, appData]);
  if (!appData[applicationId]) {
    return <CircularProgress />;
  }
  const { title, primaryRole, locations, companyName, logoUrl, token } =
    appData[applicationId];
  return (
    <a
      href={Slug.jobResults + "/?app=" + token}
      target="_blank"
      style={{
        textDecoration: "none",
        width: "100%",
        maxWidth: "720px",
        color: "inherit",
      }}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          px: 1,
          py: 1,
          backgroundColor: Color.bgDark,
          borderRadius: "12px",
          cursor: "pointer",
        }}>
        <img src={logoUrl} style={{ height: "48px" }} />
        <Stack direction="column" spacing={0.5}>
          <Box
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
            }}>
            {companyName} <span style={{ fontWeight: 400 }}>|</span> {title}
          </Box>

          <Box sx={{ fontSize: "12px", color: Color.secondaryTextGray }}>
            {primaryRole} ∙ {locations.join(" ∙ ")}
          </Box>
        </Stack>
      </Stack>
    </a>
  );
};

const ChatMessage = ({ message, prev }) => {
  const {
    userId,
    dt,
    text,
    applicationId,
    waitingForServer,
    success,
    failed,
    localId,
    serverId,
  } = message;
  const recipient = useSelector((state) => state.messages.recipient);
  const isFromUser = userId === userStr;
  const userData = useSelector((state) => state.messages.recipient);
  const textAreaRef = React.useRef(null);
  // const skipHeader =
  //   prev &&
  //   prev.userId === userId &&
  //   parseDate(dt).getTime() - parseDate(prev.dt).getTime() < 1000 * 60 * 5;
  const skipHeader =
    prev &&
    prev.userId === userId &&
    parseDate(dt).getTime() - parseDate(prev.dt).getTime() < 1000 * 60 * 20;
  useEffect(() => {
    if (textAreaRef.current) {
      // console.log(
      //   "text",
      //   textAreaRef.current.scrollWidth,
      //   textAreaRef.current.style.width
      // );
      // textAreaRef.current.style.height = "0px";
      // let targetHeight = textAreaRef.current.scrollHeight;
      // textAreaRef.current.style.height = `${targetHeight}px`;
    }
  }, [textAreaRef, text]);
  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems={isFromUser ? "flex-end" : "flex-start"}
      sx={{
        width: "100%",
      }}>
      {!skipHeader && !failed && !waitingForServer && (
        <Box
          sx={{
            paddingTop: "12px",
            alignSelf: isFromUser ? "flex-end" : "flex-start",
            wordBreak: "break-word",
          }}>
          <span style={{ fontWeight: "bold", fontSize: "14px" }}>
            {isFromUser ? "You" : `${userData.firstName} ${userData.lastName}`}
          </span>
          {/* {!isFromUser && (
            <span style={{ fontSize: "12px", color: Color.darkGreen }}>
              <span style={{ color: Color.secondaryTextGray }}> ∙ </span>
              Recruiter
            </span>
          )} */}
          <span style={{ fontSize: "12px", color: Color.secondaryTextGray }}>
            {" "}
            ∙ {prettyDate(dt)}
          </span>
        </Box>
      )}
      <Stack
        direction="column"
        spacing={1.5}
        sx={{
          // width: "100%",
          width: "fit-content",
          maxWidth: { xs: "75%", md: "60%" },
          borderRadius: "12px",
          px: 1.5,
          py: 1,
          backgroundColor: isFromUser ? Color.primary : Color.bgMed,
          color: isFromUser ? "#000" : "#000",
          position: "relative",
          transition:
            "background-color 0.2s ease-in-out, right 0.2s ease-in-out",
          ...(waitingForServer && {
            backgroundColor: Color.bgMed,
            right: `16px`,
          }),
          ...(failed && {
            backgroundColor: "#f008",
            right: `16px`,
          }),
          // backgroundColor: Color.primary,
          // backgroundColor: "#888",
          // color: Color.primary,
          // color: "#fff",
        }}>
        <Box
          sx={{
            fontSize: "14px",
            width: "fit-content",
            whiteSpace: "pre-wrap",
            position: "relative",
          }}>
          {text}
          {waitingForServer && (
            <Box
              sx={{
                position: "absolute",
                top: "0px",
                right: "-28px",
              }}>
              <CircularProgress size="12px" />
            </Box>
          )}
          {failed && (
            <Box
              sx={{
                position: "absolute",
                top: "0px",
                right: "-32px",
              }}>
              <RetryButton
                localId={localId}
                recipientId={recipient.userId}
                message={text}
              />
            </Box>
          )}
        </Box>
        {/* <textarea
          ref={textAreaRef}
          value={text}
          readOnly={true}
          style={{
            ...FontStyle.body,
            resize: "none",
            border: "none",
            outline: "none",
            fontSize: "16px",
            color: "inherit",
            backgroundColor: "inherit",
          }}
        /> */}
        {applicationId && (
          <ApplicationAttachment applicationId={applicationId} />
        )}
      </Stack>
    </Stack>
  );
};

export default ChatMessage;
